import {
  NewTabWarning,
  getNewTabTitle,
} from "metabase/common/components/ExternalLink";
import { Link } from "metabase/common/components/Link";

export const InternalLink = ({
  onInternalLinkClick,
  href,
  children,
  title,
  ...rest
}: {
  onInternalLinkClick?: (href: string) => void;
  href: string;
  children: React.ReactNode;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  const opensInNewTab = rest.target === "_blank";
  const warnedTitle = opensInNewTab ? getNewTabTitle(title) : title;

  if (onInternalLinkClick) {
    return (
      <a
        {...rest}
        title={warnedTitle}
        onClick={() => onInternalLinkClick(href)}
      >
        {children}
        {opensInNewTab && <NewTabWarning />}
      </a>
    );
  }

  return (
    <Link to={href} variant="brand" title={warnedTitle} {...rest}>
      {children}
      {opensInNewTab && <NewTabWarning />}
    </Link>
  );
};
